export default __webpack_public_path__ + "static/media/img-0105-canada-full-face.8970d7e4.png";